import React from "react";
import OtpInput from "react-otp-input";

/**
 * Inline replacement for the OTP popup. Same behaviour: 6 digits, Verify OTP calls the
 * caller's verifyOtp, the ✕ becomes "Cancel" (closes the panel, same as the old ✕).
 */
export default function PublicOtpPanel({ otp, onChange, errorMessage, onVerify, onCancel, loading, phone }) {
  return (
    <div className="bstep-card pbk-otp" role="group" aria-label="Verify your mobile number">
      <div className="pbk-otp-title">Verify your mobile number</div>
      <div className="pbk-otp-sub">
        Enter the code we just sent on your phone{phone ? ` (+${phone})` : ""}
      </div>
      <div className="pbk-otp-inputs">
        <OtpInput
          value={otp}
          onChange={onChange}
          numInputs={6}
          inputType="tel"
          renderSeparator={<span />}
          renderInput={(props) => <input {...props} autoComplete="one-time-code" />}
          shouldAutoFocus
        />
      </div>
      {errorMessage && <div className="text-danger" style={{ fontSize: "14px" }}>{errorMessage}</div>}
      <div className="pbk-otp-actions">
        <button type="button" className="btn btn-outline-secondary px-4" onClick={onCancel} disabled={loading}>
          Cancel
        </button>
        <button type="button" className="btn btn-danger px-4" onClick={onVerify} disabled={loading || String(otp || "").length !== 6}>
          {loading ? "Verifying…" : "Verify OTP"}
        </button>
      </div>
    </div>
  );
}
